module.exports = __webpack_public_path__ + "img/actions-data.a2c84de7.svg";